<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="large-panel" style="height: unset" @click.stop>
                <div class="dialog-title" v-t="'message.title_folder_selection'"></div>
                <hr class="dialog-hr">
                <el-tree
                    class="common-object-tree"
                    :props="properties"
                    :load="loadNode"
                    node-key="folderId"
                    ref="tree"
                    lazy
                    highlight-current
                    default-expanded-keys="{1}"
                    :expand-on-click-node="false"
                    @node-click="handleNodeClick"
                    :data="initialData"
                    :render-content="renderContent"
                />
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.button_back'"></el-button>
                    <el-button class="dialog-ok-button" @click="saveCheck" :disabled="selectedNode==null" v-t="'message.button_save'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import server from "@/components/ServerApi.js";
import commonUtil from '@/components/commonutil.js';
import constants from '@/components/constants.js';

export default {
    props: {
        keyVaultId: {
            type: Number,
            required: true
        },
        targetParameter: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            properties: {
                label: 'folderName',
                isLeaf: 'noChildren',
            },
            loadingScreen: null,
            selectedNode: null,
            initialData: [{
                folderId: 'root',
                folderName: 'ROOT',
                isRoot: true,
            }],
        };
    },

    methods: {
        loadNode(node, resolve) {
            this.loadingScreen = this.$loading({
                    lock: true ,
                    text: 'Loading data ...' ,
                    spinner: 'el-icon-loading' ,
                    background: 'rgba(0, 0, 0, 0)'
            });

            let parentFolderId = node.data.folderId;
            if ('isRoot' in node.data) {
                parentFolderId = null;
            }
            let self = this;
            server.post('/getstoragefolderlist', {keyVaultId: this.keyVaultId, parentFolderId: parentFolderId})
                .then((res) => {
                    switch (res.data.status) {
                        case constants.STATUS_SUCCESS:
                            let data = [];
                            for (let folderInfo of res.data.folderInfoList) {
                                folderInfo.noChildren = false; // no auto detection to reduce server complexity
                                data.push(folderInfo);
                            }
                            resolve(data);
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","loadNode").replace("{code}",res.data.status));
                            break;
                    }
                    self.closeLoadingScreen();
                })
                .catch( function ( error ) {
                    self.closeLoadingScreen();
                    commonUtil.putExceptionErrorMessage(self, "loadNode", error);
                });
        },
        closeLoadingScreen() {
            if (this.loadingScreen != null) {
                this.loadingScreen.close();
                this.loadingScreen = null;
            }
        },
        handleNodeClick(data, node, elNode) {
            this.selectedNode = data;
        },
        renderContent(h, { node, data, store }) {
            let objectIcon = require("@/assets/icon_level.svg");
            return h("span", [h("img", { attrs: { src: objectIcon ,height: "20px", style: "vertical-align: middle" } }), h("span", node.label)]);
        },
        saveCheck() {
            this.targetParameter.value = this.selectedNode.folderId;
            this.$emit('save', this.selectedNode.folderName);
        },
    }
}
</script>

<style scoped>
.setting-body {
    height:465px;
    padding:0px;
    font-size: 14px;
}
.template-select-button {
    width: 200px;
    margin-top: 15px;
    margin-bottom: 15px;
}
.step-dialog-title >>> .el-step__title {
    font-size: 12px ;
    line-height: 25px ;
}
.step-dialog-title >>> .el-step__head.is-success {
    color: #5171cb;
    border-color: #5171cb;
}
.step-dialog-title >>> .el-step__title.is-success {
    color: #5171cb;
}
.step-dialog-title {
    padding: 20px;
    width: 500px;
}
.item-titlebox {
    width: 100%;
    background-color: #f6f6f6;
    display: table;
    border-bottom: 1px #fff solid;
    margin-top: 10px;
    margin-bottom: 10px;
}
.item-titlebox-left {
    padding: 10px 0 10px 15px;
    width: 50%;
    display: table-cell;
    color: #848991;
    font-size: 12px;
    vertical-align: middle;
}
.input-form-setting {
    padding-left: 15px;
    text-align: left;
}
.common-object-tree.el-tree >>> .el-tree-node {
    min-width: 300px;;
}
.common-object-tree.el-tree {
    overflow-x: hidden;
    overflow-y: auto;
}
.common-object-tree.el-tree {
    width: 100%;
    height: 50vh;
}



</style>
